module.exports = __webpack_public_path__ + "static/media/rollkall_selected.ade24225.svg";